<template>
  <v-card :color="background('color')" :min-height="$vuetify.breakpoint.height">
    <v-img :style="backgroundStyle()" :min-height="$vuetify.breakpoint.height">
      <CarouselBox class="mt-8" :items="carouselItems" :hideDelimiter="true" :fixHeight="carouselFixHeight" @click.native="carouselHandler()" />
      <v-row class="my-7 mx-1">
        <v-col v-for="item in appTopN" :key="item.id">
          <CardBig :data="item" :key="item.id" :styleInfo="styleInfo" @click="cardHandler(item.name)" />
        </v-col>
      </v-row>
      <v-card class="transparent" flat height="100%" width="100%">
        <v-card-text>
          <v-row justify="center" align="center">
            <v-card v-for="data in appList" v-show="appList.length" class="ma-4" :key="data.id">
              <CardV :data="data" :key="data.id" :styleInfo="styleInfo" @click="cardHandler(data.name)" />
            </v-card>
          </v-row>
        </v-card-text>
      </v-card>
    </v-img>
  </v-card>
</template>

<script>
import { mapState } from 'vuex';
import CarouselBox from '@/components/CarouselBox.vue';
import CardV from '../components/CardV.vue';
import CardBig from '../components/CardBig.vue';

export default {
  name: 'Custom1',
  props: {},
  components: { CarouselBox, CardV, CardBig },
  data: () => ({}),
  computed: {
    ...mapState('dbTable', ['filterList', 'filterSubject', 'customList']),
    styleInfo() {
      if (!this.filterSubject) return {};
      return this.customList.find((x) => x.id === this.filterSubject).styleInfo;
    },
    appTopN() {
      return this.filterList.filter((x) => this.styleInfo.topN.includes(x.id));
    },
    appList() {
      return this.filterList.filter((x) => !this.styleInfo.topN.includes(x.id));
    },
    carouselFixHeight() {
      return this.styleInfo.boardHeight === '' ? 'auto' : this.styleInfo.boardHeight;
    },
    carouselItems() {
      if (!Object.prototype.hasOwnProperty.call(this.styleInfo, 'board')) return [];
      return this.styleInfo.board.map((x) => ({ src: `${process.env.VUE_APP_S3_URL}${x}` }));
    },
  },
  created() {
    if (!this.filterSubject) {
      this.$router.push({ name: 'main' });
    }
  },
  methods: {
    background(type) {
      if (!this.filterSubject || this.styleInfo.background.type !== type) return '';
      // if (this.styleInfo.background.type === 'image' && this.styleInfo.background.image === '') return './bg.jpg';
      return this.styleInfo.background.type === 'color'
        ? this.styleInfo.background.color
        : `${process.env.VUE_APP_S3_URL}${this.styleInfo.background.image}`;
    },
    backgroundStyle() {
      if (!this.filterSubject || this.styleInfo.background.type !== 'image') return '';
      if (this.styleInfo.background.image === '') {
        return {
          backgroundImage: 'url(./bg.jpg)',
          backgroundRepeat: 'repeat',
          backgroundSize: 'contain',
        };
      }
      return {
        backgroundImage: `url(${process.env.VUE_APP_S3_URL}${this.styleInfo.background.image})`,
        backgroundRepeat: 'repeat',
        backgroundSize: 'contain',
      };
    },
    carouselHandler() {
      if (Object.prototype.hasOwnProperty.call(this.styleInfo, 'boardHyperlink') && this.styleInfo.boardHyperlink !== '') {
        window.open(this.styleInfo.boardHyperlink);
      }
    },
    cardHandler(productName) {
      this.$router.push({ name: 'cardDetail', params: { productName } });
    },
  },
};
</script>
